import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../features/user/userSlice';
import jobReducer from '../features/job/jobSlice';
import favouritesReducer from '../features/favourites/favouritesSlice';
import slaReducer from '../features/sla/slaSlice';
import authReducer from '../features/auth/authSlice';
import reportReducer from '../features/reports/reportSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    favourites: favouritesReducer,
    job: jobReducer,
    sla: slaReducer,
    auth: authReducer,
    reports: reportReducer,
  }
})

export default store
